import React, { useState, useRef } from 'react';
import '../styles/Contact.css';
import ReCaptcha from './ReCaptcha';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const recaptchaRef = useRef();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleRecaptchaExpired = () => {
    setRecaptchaToken(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if reCAPTCHA token exists
    if (!recaptchaToken) {
      alert('Please complete the reCAPTCHA verification.');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      // Get backend URL from environment variable or use default
      // For local testing, this might be http://localhost/portfolio-website/backend/contact.php
      // For production, set REACT_APP_BACKEND_URL in your .env file
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '/backend/contact.php';
      
      const response = await fetch(backendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          recaptchaToken: recaptchaToken
        })
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        setSubmitStatus({ type: 'success', message: data.message });
        // Reset form and reCAPTCHA
        setFormData({ name: '', email: '', message: '' });
        setRecaptchaToken(null);
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
      } else {
        setSubmitStatus({ 
          type: 'error', 
          message: data.error || 'Failed to send message. Please try again.' 
        });
        // Reset reCAPTCHA on error
        setRecaptchaToken(null);
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus({ 
        type: 'error', 
        message: 'Network error. Please check your connection and try again.' 
      });
      // Reset reCAPTCHA on error
      setRecaptchaToken(null);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">
          I'm always open to discussing new opportunities and interesting projects
        </p>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <h3>Let's Connect</h3>
              <p>
                I'm currently looking for new opportunities and would love to hear 
                about your project. Whether you have a question or just want to say hi, 
                I'll try my best to get back to you!
              </p>
            </div>
            
            {/* <div className="contact-item">
              <h4>Email</h4>
              <a href="mailto:your.email@example.com">your.email@example.com</a>
            </div> */}
            
            {/* <div className="contact-item">
              <h4>Phone</h4>
              <a href="tel:+1234567890">+1 (234) 567-8900</a>
            </div> */}
            
            <div className="social-links">
              <h4>Follow Me</h4>
              <div className="social-icons">
                <a href="https://github.com/reactjsdev" target="_blank" rel="noopener noreferrer" className="social-link">
                  <span>GitHub</span>
                </a>
                <a href="https://ca.linkedin.com/in/floydcheng" target="_blank" rel="noopener noreferrer" className="social-link">
                  <span>LinkedIn</span>
                </a>
                {/* <a href="https://twitter.com/yourusername" target="_blank" rel="noopener noreferrer" className="social-link">
                  <span>Twitter</span>
                </a> */}
                {/* <a href="https://codepen.io/yourusername" target="_blank" rel="noopener noreferrer" className="social-link">
                  <span>CodePen</span>
                </a> */}
              </div>
            </div>
          </div>
          
          {/* <form className="contact-form" onSubmit={handleSubmit}>
            {submitStatus && (
              <div className={`form-message ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleInputChange}
                required
              ></textarea>
            </div>
            
            <div className="form-group recaptcha-container">
              <ReCaptcha
                ref={recaptchaRef}
                onChange={handleRecaptchaChange}
                onExpired={handleRecaptchaExpired}
              />
            </div>
            
            <button type="submit" className="btn btn-primary" disabled={isSubmitting || !recaptchaToken}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form> */}
        </div>
      </div>
      
      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 Floyd Cheng. All rights reserved.</p>
        </div>
      </footer>
    </section>
  );
}

export default Contact;